import { render, staticRenderFns } from "./ProfessionalActivityTaxonomyList.vue?vue&type=template&id=3d836c9d&"
import script from "./ProfessionalActivityTaxonomyList.vue?vue&type=script&lang=ts&"
export * from "./ProfessionalActivityTaxonomyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports